import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountPusherChannelName } from 'redux/selectors/pusher';
import type { PusherMessage } from 'types/pusher';
import type { ThunkDispatch } from 'types/redux';
import { usePusherSubscription } from 'utils/pusher';
import { deleteForecastIdInState, fetchForecastId } from '../redux/modules/forecast.actions';

export const useForecastsPusherSubscriptions = () => {
  const pusherChannel = useSelector(getAccountPusherChannelName)('forecasts');
  const dispatch = useDispatch<ThunkDispatch>();
  const handleFetchForecast = useCallback(
    (message: PusherMessage) => {
      dispatch(fetchForecastId(message.entity_id, { failSilently: true }));
    },
    [dispatch]
  );
  const handleDeleteForecast = useCallback(
    (message: PusherMessage) => {
      dispatch(deleteForecastIdInState(message.entity_id));
    },
    [dispatch]
  );
  usePusherSubscription(pusherChannel, 'forecast:created', handleFetchForecast);
  usePusherSubscription(pusherChannel, 'forecast:updated', handleFetchForecast);
  usePusherSubscription(pusherChannel, 'forecast:deleted', handleDeleteForecast);
};
